import BaseModel from './base_model';
import infolabsPopup from '../templates/popups/infolabs';

export default class Infolab extends BaseModel {
	/**
	 * Represents an InfoLab linked to the server API.
	 * @constructor
	 * @param {integer} id - The id for the InfoLabs API wrapper.
	 */
	constructor(id) {
		super();
		this.id = id;
		this.url = W.api_root + 'infolabs' + '/' + id + '.json';
		this.key = 'Infolab_' + id;
		this.object_type = 'infolab';
	}

	setHtmlView() {
		this.htmlView = W.api_root + 'map_objects/' + this.data.map_object_id + '.html';
	}

	popupContent() {
		this.setHtmlView();
		return infolabsPopup(this);
	}
}
